import React, { Component } from 'react';
import styled, { withTheme } from 'styled-components';
import SimpleCarousel from '@flow/components/carousel/SimpleCarousel';
import { Settings as CarouselSettings } from 'react-slick';

const CarouselImage = styled.figure`
  display: block;
  background-image: url(${props => props.theme.isRetina ? props.image['large'] : props.image['medium']});
  background-size: cover;
  background-position: center;
  height: 100vh !important;
  width: 100%;
  
  @media (max-width: 1023px) {
    background-image: url(${props => props.theme.isRetina ? props.image['large'] : props.image['medium']});
    height: 0;
    height: ${575 / (1023 * 0.01)}vw !important;
  }
`;

const Carousel = styled.div`
  position: relative;
      
  ul.slick-dots {
    position: absolute;
    width: 100%;
    bottom: ${props => props.theme.topBarHeight / 10}em;
    left: 0;
    margin-bottom: 3em;
  }
  
  @media (max-width: 1023px) {
    ul.slick-dots {
      bottom: 0;
    }
  }
`;

interface State {
  isNarrow: boolean;
  carouselSettings: CarouselSettings;
  imagePool: string;
  imageIndex: number;
}

interface Props {
  images: any;
  theme: any;
}

class ImageCarousel extends Component<Props, State> {
  constructor(props: Props) {
    super(props);

    this.state = {
      isNarrow: false,
      imagePool: 'portrait',
      imageIndex: 0,
      carouselSettings: {
        dots: false,
        arrows: false,
        autoplay: false,
        autoplaySpeed: 4500,
        speed: 500,
        fade: true,
        cssEase: 'linear',
        // lazyLoad: true, TODO: Breaks the fade effect on first show
      }
    }
  }

  componentDidMount() {
    this._updateWindowDimensions();
    window.addEventListener('resize', this._updateWindowDimensions);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._updateWindowDimensions);
  }

  private _updateCarouselSettings = (imagePool: any): CarouselSettings => {
    let carouselSettings = this.state.carouselSettings;
    carouselSettings.dots = imagePool.length > 1;
    carouselSettings.autoplay = imagePool.length > 1;

    return carouselSettings;
  };

  private _updateWindowDimensions = () => {
    const {
      images,
      theme: {
        containerMaxW,
        twoColToOneColLayout
    }} = this.props;

    let isNarrow: boolean = Math.min(window.innerWidth, containerMaxW) < twoColToOneColLayout;
    if (this.state.isNarrow !== isNarrow) {
      let imagePool: string = isNarrow ? 'landscape' : 'portrait';

      let carouselSettings: CarouselSettings = this._updateCarouselSettings(images[imagePool]);

      this.setState({isNarrow, carouselSettings, imagePool}, () => {});
    } else {
      if (!this.state.carouselSettings['dots'] &&
          images &&
          images[this.state.imagePool] &&
          images[this.state.imagePool].length > 1) {
        let carouselSettings: CarouselSettings = this._updateCarouselSettings(images[this.state.imagePool]);
        this.setState({carouselSettings}, () => {});
      }
    }
  };

  render() {
    const {
      images
    } = this.props;
    // ToDo: Default state should be saved to the redux??

    return (
      <div>
        {images && images[this.state.imagePool] && images[this.state.imagePool].length > 1 &&
        <Carousel>
          <SimpleCarousel settings={this.state.carouselSettings}>
            {images[this.state.imagePool].map((image: any, index: number) =>
              <CarouselImage key={index} image={image} className={'slick-slide'}/>
            )}
          </SimpleCarousel>
        </Carousel>
        }

        {images && images[this.state.imagePool] && images[this.state.imagePool].length === 1 &&
        <CarouselImage image={images[this.state.imagePool][0]}/>
        }
      </div>
    )
  }
}

export default withTheme(ImageCarousel);


// WEBPACK FOOTER //
// /Users/ek1z/dev/flowfestival-com/src/components/carousel/ImageCarousel.tsx